import { render, staticRenderFns } from "./menu-sales-orderstock.vue?vue&type=template&id=e43c420e&"
import script from "./menu-sales-orderstock.vue?vue&type=script&lang=js&"
export * from "./menu-sales-orderstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports